module.exports = __webpack_public_path__ + "img/badges1.a0a6f696.png";